var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDangerTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.4854V10.7871M10 17.8561C5.98203 17.8561 3.97304 17.8561 2.81167 17.0123C1.79868 16.2763 1.14555 15.1451 1.01467 13.8998C0.864614 12.4721 1.86911 10.7323 3.87809 7.25264C5.88708 3.77297 6.89157 2.03314 8.203 1.44926C9.34687 0.93997 10.6531 0.93997 11.797 1.44926C13.1084 2.03314 14.1129 3.77297 16.1219 7.25264C18.1309 10.7323 19.1354 12.4721 18.9853 13.8998C18.8544 15.1451 18.2013 16.2763 17.1883 17.0123C16.027 17.8561 14.018 17.8561 10 17.8561Z",
    stroke: "#FF536D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.7311C10.625 14.0763 10.3452 14.3561 10 14.3561C9.65482 14.3561 9.375 14.0763 9.375 13.7311C9.375 13.3859 9.65482 13.1061 10 13.1061C10.3452 13.1061 10.625 13.3859 10.625 13.7311Z",
    fill: "#FF536D",
    stroke: "#FF536D",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerTriangle);
export default __webpack_public_path__ + "static/media/DangerTriangle.22032652bb0570244b07866e074ce83e.svg";
export { ForwardRef as ReactComponent };